<template>
    <div class="d-flex flex-column overflow-auto h-100">
        <div class="p-4 flex-grow-1 overflow-auto">

            <div class="mb-3-rem" v-if="transferToMulti.length == 0">
                <v-label class="label_required">{{ $t("res_Label_ForwardTo") }} *</v-label>
                <StructureUserSelector :showInternalUsers="true" :showExternalUsers="false"
                    :showInternalStructures="true"
                    :showExternalStructures="false" :excludeSelf="false"
                    :isMultiple="false" :selectedStructureUser="transferTo"
                    @structureUserSelectChanged="transferToSelectedChange"
                    :disabled="disableRecipient" :addressBook_header="$t('res_Label_SelectStructureOrUser')"
                    :hideStructureWithDisableTransfer="true">
                </StructureUserSelector>
            </div>

            <div class="mb-3-rem" v-if="transferToMulti.length > 0">
                <v-label class="label_required">{{ $t("res_Label_ForwardTo") }} *</v-label>
                <StructureUserSelector :showInternalUsers="true" :showExternalUsers="false"
                    :showInternalStructures="true" :showExternalStructures="false"
                    :excludeSelf="true" :isMultiple="true"
                    :selectedStructureUsersList="transferToMulti"
                    @structureUserSelectChanged="transferToMultipleSelectedChange"
                    :disabled="disableRecipient" :addressBook_header="$t('res_Label_SelectStructureOrUser')">
                </StructureUserSelector>
            </div>

            <div class="mb-3-rem">
                <v-label>{{ $t("res_Label_CC") }}</v-label>
                <StructureUserSelector :showInternalUsers="true" :showExternalUsers="false"
                    :showInternalStructures="true"
                    :showExternalStructures="false" :excludeSelf="false"
                    :isMultiple="true" :selectedStructureUsersList="transferCC"
                    @structureUserSelectChanged="ccSelectedChange"
                    :disabled="disableRecipient" :addressBook_header="$t('res_Label_SelectStructureOrUser')">
                </StructureUserSelector>
            </div>

            <div class="mb-3-rem">
                <div class="d-flex gap-4">
                    <div class="flex-1">
                        <v-label class="label_required">{{ $t("res_Label_Purpose") }} *</v-label>
                        <multiselect :disabled="disableRecipient" class="light-bg add-arrow" v-model="purpose"
                            label="name" track-by="id" open-direction="bottom" :options="purpose_items"
                            :searchable="true" :loading="loading" :internal-search="false" :clear-on-select="false"
                            :close-on-select="true" :options-limit="300" :max-height="600" :show-no-results="false"
                            :hide-selected="false" :multiple="false" ref="multiselect1" :placeholder="$t('res_Label_SelectOption')">
                        </multiselect>
                    </div>
                    <div class="flex-1">
                        <v-label class="label_required">{{ $t("res_Label_DueDate") }}</v-label>
                        <v-menu content-class="p-0" v-model="transfer_date_menu" :close-on-content-click="false"
                            transition="scale-transition" offset-y left min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field :value="utils.dateFormat(dueDate)" label="" v-bind="attrs" v-on="on" solo append-icon="mdi-calendar">
                                    <template v-slot:append>
                                        <v-icon v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                    </template>
                                </v-text-field>
                            </template>
                            <v-date-picker v-model="dueDate" @input="transfer_date_menu = false" :min="nowDate"></v-date-picker>
                        </v-menu>
                    </div>
                </div>
            </div>

            <div class="pt-2" style="margin-bottom: 23px; line-height: 0">
                <v-label>{{ $t("res_Label_Note") }}</v-label>
                <textarea class="text-area" style="height:100px" v-model="note"></textarea>
            </div>
            <div class="mb-3-rem">
                <v-checkbox class="float-left m-0 p-0" v-model="followup"></v-checkbox>
                <label class="checkbox-label">{{ $t("res_Label_NeedFollowUp") }}</label>
            </div>
        </div>

        <v-card-actions class="top-shadow gap-3">
            <v-btn class="light-blue flex-1" @click="cancelDialog">{{ $t('res_ButtonText_Cancel') }}</v-btn>
            <v-btn class="light-blue flex-1" @click="Send(0)">Reject</v-btn>
            <v-btn class="primary flex-1" @click="Send(1)">Advance</v-btn>
        </v-card-actions>
    </div>
</template>

<script>
import axios from 'axios';
import constants from '@/assets/js/constants'
import Multiselect from 'vue-multiselect'
import * as utils from '@/assets/js/common.js'
import { McWysiwyg } from '@mycure/vue-wysiwyg'
import { mapGetters } from 'vuex'
import debounce from "lodash.debounce"
import StructureUserSelector from '@/components/StructureUserSelector.vue'

export default {
    name: 'TransferFormWorkflow',
    components: { Multiselect, McWysiwyg, StructureUserSelector },
    data() {
        return {

            dueDate: new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000).toISOString().substr(0, 10),
            loading: false,
            structures: [],
            transferDate: '',
            CCstructures: [],
            purpose_items: [],
            Forwarded: [],
            transfer_date_menu: false,
            note: '',
            followup: false,
            nowDate: new Date().toISOString().slice(0, 10),
            debouncedHandler1: null,
            debouncedHandler2: null,
            utils: utils,
            constants: constants,
            workflowStepsInfo: {},
            workflowStepInfo: {}
        }
    },
    props:
    {
        rejected: { type: Boolean, default: false },
        disableRecipient: { type: Boolean, default: false },
        transferId: { type: Number, default: 0 },
        documentId: { type: Number, default: 0 },
        transferTo: { type: Object, default: {} },
        transferToMulti: { type: Array, default: [] },
        successMessage: { type: String, default: 'res_Msgs_DocumentSignedAndSent' },
        transferCC: { type: Array, default: [] },
        purpose: { type: Object, default: {} },
        delegationId: { type: Number, default: 0 },
        transferFormDialog: { type: Boolean, default: false },
        checkForAttachmentsUploadMultiApproval: { type: Boolean, default: false },
        defaultDueDate: { type: String, default: false },
    },
    beforeMount() {
        this.debouncedHandler1 = debounce(query => {
            if (query == '') return;
            axios.get(constants.baseApiUrl + 'StructureUser/search?showUsers=true&showInternalStructures=true&showExternalStructures=false&search=' + query)
                .then(res => this.structures = res.data)
                .catch(err => console.log(err));
        }, 200);

        this.debouncedHandler2 = debounce(query => {
            if (query == '') return;
            axios.get(constants.baseApiUrl + 'StructureUser/search?showUsers=true&showInternalStructures=true&showExternalStructures=false&search=' + query)
                .then(res => this.CCstructures = res.data)
                .catch(err => console.log(err));
        }, 200);
    },
    methods:
    {
        openMultiSelectCtrl(id) {
            if (id === 1) this.$refs.multiselect1.activate()
        },
        removeToItem(itemId) {
            this.transferTo = this.transferTo.filter(item => item.id !== itemId);
        },
        removeCCItem(itemId) {
            this.transferCC = this.transferCC.filter(item => item.id !== itemId);
        },
        CapitalizeFirstLetter(str) {
            return utils.CapitalizeFirstLetter(str);
        },
        GetMultiSelectSubHeaderDisplay(options) {
            return utils.GetMultiSelectSubHeaderDisplay(options)
        },
        asyncFindTransferToStructure(query) {
            if (query == '') return;
            axios.get(constants.baseApiUrl + 'StructureUser/search?showUsers=true&showInternalStructures=true&showExternalStructures=false&search=' + query)
                .then(res => {
                    this.structures = res.data;
                    this.loading = false;
                })
                .catch(err => console.log(err));
        },
        asyncFindTransferCCStructure(query) {
            if (query == '') return;

            axios.get(constants.baseApiUrl + 'StructureUser/search?showUsers=true&showInternalStructures=true&showExternalStructures=false&search=' + query)
                .then(res => {
                    this.CCstructures = res.data;
                    this.loading = false;
                })
                .catch(err => console.log(err));
        },
        Send(isAdvance) 
        {
            window.showLoading()
            this.transfer(isAdvance)
        },
        closeDialog() 
        {
            this.clearForm()
            this.$emit('closeTransformDialog');
        },
        transfer(isAdvance) 
        {
            if ((this.transferTo != null && this.transferTo != undefined && this.transferTo != '' && this.transferTo.id != null && this.transferTo.id != undefined && this.transferTo.id != '')
                || (this.transferToMulti != null && this.transferToMulti != undefined && this.transferToMulti.length != 1)) 
            {
                if (this.purpose == null || this.purpose == undefined || this.purpose == '' || this.purpose.id == null || this.purpose.id == undefined || this.purpose.id == '') {
                    window.hideLoading()
                    window.showAlert('res_Msgs_FillRequired', 'warning')
                    return;
                }

                var transferTos = [];
                if (this.transferTo != null && this.transferTo != undefined && this.transferTo != '' && this.transferTo.id != null && this.transferTo.id != undefined && this.transferTo.id != '')
                    transferTos.push(this.transferTo);
                else
                    transferTos = this.transferToMulti.filter(item => item !== this.transferToMulti[0]);

                var transferCCs = this.transferCC.filter(item => item !== this.transferCC[0]);
                var params = {
                    TransferId: this.transferId,
                    DocumentId: this.documentId,
                    ForwardTo: transferTos,
                    ForwardCC: transferCCs,
                    Purpose: this.purpose.id,
                    DueDate: this.dueDate,
                    Note: this.note,
                    FollowUp: this.followup,
                    DelegationId: this.delegationId
                }

                axios.post(constants.baseApiUrl + (isAdvance ? 'Workflow/AdvanceDocument' : 'Workflow/RejectDocument'), params)
                    .then(res => 
                    {
                        if (res.data == 'CantTransfer') 
                        {
                            window.showAlert('res_Msgs_CantTransfer', 'success')
                            return;
                        }
                        window.showAlert(this.successMessage, 'success')
                        window.hideLoading()
                        this.closeDialog();
                    })
                    .catch(err => console.log(err))
                    .finally(() => window.hideLoading())
            }
            else
            {
                window.hideLoading()
                window.showAlert('res_Msgs_FillRequired', 'warning')
                return;
            }
        },
        clearForm() 
        {
            this.rejected = false
            this.disableRecipient = false
            this.note = ''
            this.transferTo = {}
            this.transferCC = []
            // this.purpose = 0
            this.dueDate = new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000).toISOString().substr(0, 10)
            this.followup = false
            this.checkForAttachmentsUploadMultiApproval = false
            try 
            {
                if (this.defaultDueDate) {
                    const defaultDueDateWithoutTime = utils.formatDateFromString(this.defaultDueDate);
                    const currentDateWithoutTime = new Date();

                    defaultDueDateWithoutTime.setHours(0, 0, 0, 0);
                    currentDateWithoutTime.setHours(0, 0, 0, 0);

                    if (defaultDueDateWithoutTime >= currentDateWithoutTime) {
                        this.dueDate = this.defaultDueDate;
                    }
                }
                // clearing the wsiwyg editor
                document.getElementById('editor').innerText = ''
                var arrElements = document.all['editor'];
                for (let index = 0; index < arrElements.length; index++) {
                    arrElements[index].innerText = '';
                }
            }
            catch (e) { }
        },
        cancelDialog() {
            this.clearForm()
            this.$emit('cancelCorrespondenceDocument');
        },
        removeItem(itemId) {
            this.transferToMulti = this.transferToMulti.filter(item => item.id !== itemId);
        },
        transferToMultipleSelectedChange(items) 
        {
            this.transferToMulti = this.handleFirstElement(items, {name: 'temp', isTemp: true}); 
        },
        transferToSelectedChange(item){
            this.transferTo = item;
        },
        ccSelectedChange(items){
            this.transferCC = this.handleFirstElement(items, {name: 'temp', isTemp: true});
        },
        handleFirstElement(data, tempItem){
            if(data.length > 0) {
                var shouldAddTemp = true;
                for (var i = 0; i<data.length; i++){
                    if(data[i].isTemp 
                        || data[i].id == undefined 
                        || data[i].id == null){
                            shouldAddTemp = false;
                            break;
                    }
                }
                if(shouldAddTemp) {
                    if(tempItem == undefined || tempItem == null){
                        tempItem = {isTemp: true, name: 'temp'};
                    }
                    data = [tempItem, ...data];
                } else if(data.length == 1){
                    data = [];
                }
            }
            return data;
        },
    },
    mounted() 
    {
        this.purpose_items = [...this.allTransferPurposes]
    },
    watch:
    {
        transferFormDialog(newVal, oldVal) 
        {
            if (newVal != oldVal) 
            {
                if (newVal == true)
                {
                    this.clearForm();
                    this.purpose_items = [...this.allTransferPurposes]
                    axios.get(constants.baseApiUrl + 'Workflow/GetWorkflowNextReciever?documentId=' + this.documentId)
                        .then(res => 
                        {
                            
                            this.workflowStepsInfo = res.data
                            this.workflowStepsInfo.forEach(element => {
                                this.workflowStepInfo = JSON.parse(element.stepInfo.replace('\"', '"'))
                            });
                            console.log(this.workflowStepsInfo)

                            this.workflowStepsInfo.forEach(element => {
                                if (element.isCced)
                                {
                                    this.transferCC.push({ id: element.id, name: element.name })
                                }
                                else
                                {
                                    this.transferTo = { id: element.id, name: element.name }
                                    this.purpose = this.purpose_items.find(item => item.id == element.purpose)
                                }
                            });

                        })
                        .catch(err => console.log(err));
                }
                else 
                {
                    this.clearForm()
                }
            }
        },
        transferTo() 
        {
            this.Forwarded = []
        }
    },
    computed: mapGetters(['allTransferPurposes']),
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
    .radio-label { display: inline-block; margin-right: 10px; }
    .radio-input { margin-right: 5px; }

    .ad__box { margin-left: 9px; margin-right: 9px; padding-top: 6px; }
    .ad__text { margin-bottom: 5px; }
    .ad__text__bold { font-weight: bold; }
    .ad__box p { margin-bottom: 0px; }

    .multiselect__option--highlight .v-avatar { color: #205CDF !important; }
    .multiselect__select { display: none !important; }
</style> 